import { Trans } from '@lingui/macro';
import { LoadingButton } from '@mui/lab';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import { TableEmpty } from 'components';
import { PopupController } from 'types/Common';

type PopupProps = PopupController;

const EKYCInformationPopup = ({ onSuccess, onClose }: PopupProps) => {
  return (
    <>
      <DialogTitle>
        <Trans>eKYC Information</Trans>
      </DialogTitle>

      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Trans>STT</Trans>
                </TableCell>
                <TableCell>
                  <Trans>Image Url</Trans>
                </TableCell>
                <TableCell>
                  <Trans>Authenticity</Trans>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
              <TableEmpty />
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <LoadingButton variant='outlined' onClick={onClose}>
          <Trans>Cancel</Trans>
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default EKYCInformationPopup;
